module.exports = __webpack_public_path__ + "img/tool-know.7d0e11a.jpg";